import { CompanyFormFields } from '@/types/companies';

export const initialCompanyForm: CompanyFormFields = {
  uuid: '',
  name: '',
  brandingThemeId: '',
  advisorOfficeType: undefined,
  relationshipManagerId: '',
  teammateCreatePerm: false,
  teammateUpdatePerm: true, // Only this one checked by default
  teammateDeactivateReactivatePerm: false,
  divisionCreatePerm: false,
  divisionUpdatePerm: false,
  divisionDeletePerm: false,
  rateSavingInterest: '',
  minimumInitDeposit: '0.00',
  alias: '',
  feeIncomingDomestic: '',
  feeOutcomeDomestic: '',
  feeMonthlySavingAccount: '',
  useProgramIncomingWireFee: true,
  useProgramOutgoingWireFee: true,
  useProgramMonthlySavingsFee: true,
  debitCardProgramId: '',
  lendingEnabled: false,
};
